import { connect } from 'react-redux'
import { compose, withProps, withState } from 'recompose'
import { withRouter } from 'react-router-dom'
import qs from 'qs'
import Cookies from 'js-cookie'

import { getErrorMessage } from 'api'
import notif from 'services/notification'
import {
  register,
  selectError,
  selectIsRegistering,
  selectIsAuthenticating,
  clearError,
} from 'auth/modules/auth'
import { unsetGuestCheckoutEmail } from 'store/guest-checkout'
import {
  withFormValidator,
  isRequired,
  isEmail,
  isName,
  isMobileNum,
  composeValidators as composeV,
} from 'utils/validator'
import getHistory from 'services/history'
import { COOKIE_REDIRECT_PATH } from 'const/cookie'

export default compose(
  connect(
    state => ({
      asyncError: selectError(state),
      isAuthenticating:
        selectIsRegistering(state) || selectIsAuthenticating(state),
    }),
    (dispatch, { onSuccess = () => {} }) => ({
      onSubmit: ({ referralCode: referredBy, ...fields }) =>
        dispatch(register({ referredBy, ...fields }))
          .then(onSuccess)
          .then(dispatch(unsetGuestCheckoutEmail()))
          .then(() => notif.success({ title: 'Registration successful' }))
          .then(() => {
            const redirectPath = Cookies.get(COOKIE_REDIRECT_PATH)
            if (redirectPath) {
              Cookies.remove(COOKIE_REDIRECT_PATH)
              getHistory().push(redirectPath)
            }
          })
          .catch(error => {
            notif.error({
              title: 'Registration failed',
              message: getErrorMessage(error),
              error,
            })
            throw error
          }),
      clearAsyncError: () => dispatch(clearError()),
    }),
  ),

  withRouter,

  withProps(({ location }) => ({
    initValues: {
      referralCode:
        qs.parse(location.search, { ignoreQueryPrefix: true }).referralcode ||
        '',
    },
    onSubmitFail: () =>
      notif.error({
        title: 'Registration failed',
        message: 'please check the form errors',
      }),
  })),

  withState(
    'isReferralCodeVisible',
    'setIsReferralCodeVisible',
    ({ location }) =>
      !!qs.parse(location.search, { ignoreQueryPrefix: true }).referralcode,
  ),

  withFormValidator({
    firstName: composeV(isRequired, isName)('First name'),
    lastName: composeV(isRequired, isName)('Last name'),
    email: composeV(isRequired, isEmail)('Email'),
    mobile: isMobileNum('Mobile'),
    password: isRequired('Password'),
    referralCode: null,
  }),
)
